import React from 'react';
import PropTypes from 'prop-types';
import WizardLayoutEmet from './WizardLayoutEmet';

const WizardEmet = ({variant, validation, progressBar, certification}) => {
	return (
		<WizardLayoutEmet variant={variant}
			validation={validation}
			progressBar={progressBar}
			certification={certification} />
	);
};

export default WizardEmet;
